import React, {
  FunctionComponent,
  ReactNode,
  useEffect,
  useState,
} from "react";
import { useTranslation } from "react-i18next";

import { pushNotification } from "../../stores/hooks/useToasts";
import { LinearProgress } from "../../ui/LinearProgress";
import { loadMaps } from "./googleMapsLoader";

export const WithGoogleMaps: FunctionComponent<{ children: ReactNode }> = ({
  children,
}) => {
  const { t } = useTranslation();
  const [done, setDone] = useState(Boolean(window.google?.maps));
  const [error, setError] = useState(false);

  useEffect(() => {
    loadMaps()
      .then(() => {
        setDone(true);
      })
      .catch(() => {
        setError(true);
        pushNotification({ message: "toast.mapsUnavailable" });
      });
  }, []);

  if (error) {
    return (
      <p className="text-ink-2 text-sm py-4">
        {t("toast.mapsUnavailable")}
      </p>
    );
  }

  return done ? <>{children}</> : <LinearProgress className="h-0.5" />;
};

/**
 * @see docs/worklog/TW-894-hyundai-national-not-loading/rfc.md
 * @see docs/worklog/TW-894-hyundai-national-not-loading/tfc.md
 */
